module.exports = __webpack_public_path__ + "static/img/bg11.f045651.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/backgrounds/bg11.jpg
// module id = 1033
// module chunks = 5